import axios from 'axios';
import { useEffect, useState } from 'react';
import { getItem, getItemSession, setItemSession } from './setItem';

const useApi = ({ url, local }) => {
  const [data, setData] = useState(null);
  const [response, setResponse] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${getItem({})}` },
        });
        setData(response?.data?.data);
        setResponse(response?.data);
        if (local) {
          setItemSession({
            key: local,
            value: JSON.stringify(response?.data?.data),
          });
          setItemSession({
            key: `response:${local}`,
            value: JSON.stringify(response?.data),
          });
        }
      } catch (error) {
        setError(error?.response?.data);
      }
      setIsLoading(false);
    };

    if (url) {
      let localData = '';
      let localResponse = '';

      if (local) {
        localData = getItemSession({ key: local });
        localResponse = getItemSession({ key: `response:${local}` });
      }

      if (!localData) {
        fetchData();
      } else {
        setData(JSON.parse(localData));
        setResponse(JSON.parse(localResponse));
      }
    }

    // Clean-up function to cancel request if component unmounts
    return () => {};
  }, [url, local]);

  return { data, isLoading, error, response };
};

export default useApi;
